import { forwardRef } from 'react';
import { Button, ButtonProps } from '../ui/button';
import { cn } from '../../lib/utils';
import { Loader2, LucideProps } from 'lucide-react';

interface IconButtonProps extends ButtonProps {
  Icon: React.ForwardRefExoticComponent<
    Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
  >;
  isLoading?: boolean;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, Icon, children, isLoading, ...props }, ref) => {
    return (
      <Button
        className={cn('transform transition-transform', className)}
        ref={ref}
        {...props}
      >
        {isLoading ? (
          <span className='mr-2'>
            <Loader2 className='h-4 w-4 animate-spin' />
          </span>
        ) : (
          <span className='pr-2'>
            <Icon className='h-4 w-4' strokeWidth={2.9} />
          </span>
        )}
        {children}
      </Button>
    );
  },
);

IconButton.displayName = 'IconButton';
